import { ReactComponent as DocIcon } from '@/assets/doc.svg'; //文档
import { ArrowRightOutlined, DeleteOutlined, RightOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Checkbox, DatePicker, Form, Image, Input, Progress, Radio, Rate, Select, Tabs, Tooltip } from 'antd';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { getDownloadPreSignedUrl, getUploadPreSignedUrl } from '../../utils/api.js';
import './index.scss';
import {
  AgentContent,
  AgentContentWrapper,
  AgentInfo,
  AgentList,
  ChatMessageAgentWrapper,
  ChatMessageCustomerWrapper,
  ChatMessageEvent,
  ContentImage,
  ContentVideo,
  CustomerContent,
  CustomerContentFooter,
  CustomerContentWrapper,
  CustomerInfo,
  CustomerMessageWarpper,
  EvaluationDiv,
  EvaluationLine,
  FileUploading,
  LeftWrapper,
  LikeButContainer,
  ListItem,
  MessageBody,
  MessageQuote,
  RightWrapper,
  Spinner,
  UploadContainer,
} from './styled';
const { RangePicker } = DatePicker;
const { TextArea } = Input;

// 解析markdown内容
import ReactMarkdown from 'react-markdown';
// 客户图标
import customer from '../../assets/user.svg';
// 上传的关闭按钮
import close from '../../assets/closeIcon2.svg';
import { messageDateType, messageRole } from '../../constant';
const MsgReadedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM11.5811 5.92285C11.7773 5.72888 12.0939 5.73078 12.2881 5.92676C12.4821 6.12288 12.481 6.43952 12.2852 6.63379L7.3877 11.4824C7.29289 11.5763 7.16368 11.6282 7.03027 11.627C6.89708 11.6255 6.7696 11.5711 6.67676 11.4756L3.64062 8.34766C3.44889 8.14947 3.4544 7.83276 3.65234 7.64062C3.85053 7.44889 4.16724 7.4544 4.35938 7.65234L7.04199 10.417L11.5811 5.92285Z"
      fill="#00B900"
    />
  </svg>
);
const MsgReadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="7.5" stroke="#999999" />
  </svg>
);
const agent = (color = '#3463FC') => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1199_12716)">
      <circle cx="10" cy="10" r="10" fill="white" />
      <path
        d="M10 0C15.523 0 20 4.47696 20 10C20 15.523 15.523 20 10 20C4.47696 20 0 15.523 0 10C0 4.47696 4.47696 0 10 0ZM9.97783 4.41261C7.28217 4.41261 5.08956 6.64478 5.08956 9.40826C5.08956 9.43087 5.0913 9.45304 5.09391 9.47522C5.08957 9.51087 5.08956 9.54739 5.08956 9.58391V10.9874C5.05217 11.7222 5.64348 12.3478 6.41435 12.3887H6.74565C7.51783 12.3483 8.11 11.7213 8.07174 10.9857V9.58348C8.10956 8.8487 7.51826 8.22261 6.74739 8.1813H6.41565C6.36844 8.18125 6.32126 8.18386 6.27435 8.18913C6.62435 6.91348 7.67 5.91696 9.00913 5.58304C11.0552 5.07304 13.1474 6.23957 13.683 8.18913C13.6358 8.18383 13.5884 8.18122 13.5409 8.1813H13.2096C12.4378 8.2213 11.8457 8.84826 11.8835 9.58348V10.9878C11.8452 11.723 12.4378 12.3504 13.2096 12.3904H13.4539C13.0638 13.0909 12.4534 13.6431 11.7174 13.9613C11.6277 13.8689 11.5146 13.8025 11.3903 13.7691C11.2659 13.7356 11.1348 13.7364 11.0109 13.7713L10.05 14.0435C9.64 14.187 9.41348 14.6061 9.52826 15.0078L9.53826 15.05C9.63652 15.4287 10.0383 15.6604 10.4365 15.5665L11.397 15.2943C11.7057 15.1952 11.9217 14.9291 11.9448 14.6204C13.0587 14.1296 13.9152 13.2287 14.3152 12.1243C14.4883 11.9897 14.628 11.8169 14.7235 11.6195C14.8191 11.4221 14.8678 11.2054 14.8661 10.9861V9.58348L14.8617 9.47478C14.8648 9.45304 14.8661 9.43043 14.8661 9.40826C14.8661 6.64478 12.6735 4.41261 9.97783 4.41261Z"
        fill="#3463FC"
      />
      <g clipPath="url(#clip1_1199_12716)">
        <circle cx="10" cy="10" r="10" fill={color} />
        <g clipPath="url(#clip2_1199_12716)">
          <path
            d="M16.1033 8.30923C15.8092 5.14746 13.2357 2.64746 10.0004 2.64746C6.76511 2.64746 4.11805 5.14746 3.89746 8.30923C3.16217 8.60334 2.64746 9.41217 2.64746 10.2945V11.6916C2.64746 12.868 3.60334 13.8239 4.77981 13.8239H5.58864C5.88276 13.8239 6.10334 13.6033 6.10334 13.3092V8.67687C6.10334 8.38276 5.88276 8.16217 5.58864 8.16217H4.92687C5.29452 5.66217 7.35334 3.7504 10.0004 3.7504C12.5739 3.7504 14.7063 5.66217 15.0739 8.16217H14.4122C14.118 8.16217 13.8975 8.38276 13.8975 8.67687V13.2357C13.8975 13.5298 14.118 13.7504 14.4122 13.7504H14.6328C14.4122 15.0004 13.4563 15.7357 11.618 15.8828C11.471 15.6622 11.1769 15.5151 10.8828 15.5151H9.85334C9.33864 15.5151 8.97099 15.8828 8.97099 16.3975C8.97099 16.9122 9.33864 17.2798 9.85334 17.2798H10.8828C11.1769 17.2798 11.3975 17.2063 11.5445 16.9857C14.0445 16.8386 15.4416 15.7357 15.6622 13.6769C16.618 13.5298 17.3533 12.6475 17.3533 11.618V10.221C17.3533 9.41217 16.8386 8.60334 16.1033 8.30923ZM5.07393 9.41217V12.5004C5.07393 12.6475 5.0004 12.721 4.85334 12.721H4.77981C4.19158 12.721 3.7504 12.2798 3.7504 11.6916V10.2945C3.7504 9.70628 4.19158 9.26511 4.77981 9.26511H4.85334C5.0004 9.19158 5.07393 9.33864 5.07393 9.41217ZM16.3239 11.6916C16.3239 12.2798 15.8828 12.721 15.2945 12.721H15.1475C15.0004 12.721 14.9269 12.6475 14.9269 12.5004V9.41217C14.9269 9.26511 15.0004 9.19158 15.1475 9.19158H15.221C15.8092 9.19158 16.2504 9.63276 16.2504 10.221V11.6916H16.3239Z"
            fill="white"
          />
          <path
            d="M10.0007 13.8963C9.04481 13.8963 8.23598 13.5286 7.42716 12.7933C7.20657 12.5727 7.20657 12.2786 7.42716 12.058C7.64775 11.8374 7.94187 11.8374 8.16245 12.058C9.33892 13.161 10.736 13.161 11.8389 12.058C12.0595 11.8374 12.3536 11.8374 12.5742 12.058C12.7948 12.2786 12.7948 12.5727 12.5742 12.7933C11.7654 13.5286 10.9566 13.8963 10.0007 13.8963Z"
            fill="white"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1199_12716">
        <rect width="20" height="20" fill="white" />
      </clipPath>
      <clipPath id="clip1_1199_12716">
        <rect width="20" height="20" fill="white" />
      </clipPath>
      <clipPath id="clip2_1199_12716">
        <rect width="14.7059" height="14.7059" fill="white" transform="translate(2.64746 2.64746)" />
      </clipPath>
    </defs>
  </svg>
);
const HotIssusIcon = (color = '#3463FC') => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
      <g clip-path="url(#clip0_2504_14923)">
        <path
          d="M7.50892 11.3524C7.59138 11.3081 7.66787 11.2699 7.73718 11.2185C8.35982 10.8349 8.7542 10.2911 8.94064 9.67803C9.26212 8.62396 8.96335 7.46711 8.39448 6.55884C7.86984 5.72706 7.6105 4.75187 7.60333 3.77906C7.15876 4.31924 7.12649 5.06259 6.99264 5.72587C6.85281 6.43455 6.38314 6.81579 5.85611 6.92693C5.62068 6.96876 5.37927 6.96159 5.151 6.90542C4.92274 6.84806 4.70046 6.73094 4.51641 6.57199C4.09096 6.20032 3.84955 5.58723 4.09096 4.79967C4.40288 3.80296 4.24393 2.90067 3.55795 2.12147C3.68463 3.65597 3.16357 4.97654 2.33776 6.25768C1.98521 6.80384 1.74739 7.41333 1.63266 8.02044C1.41037 9.19283 1.6458 10.523 2.71302 11.2089C2.77636 11.2567 2.85284 11.295 2.92216 11.3332C2.82655 10.7644 2.91857 10.1608 3.15759 9.63023C3.36434 9.17251 3.68463 8.77215 4.09096 8.4925C4.40288 8.28934 4.75782 8.14951 5.14503 8.12441C5.39361 8.10171 5.60872 8.28934 5.62785 8.53433C5.63741 8.69328 5.56451 8.83908 5.44978 8.92751C5.38644 8.98129 5.33863 9.03866 5.30398 9.09602C5.22749 9.23943 5.19283 9.39719 5.20239 9.55255C5.24661 10.0772 5.61589 10.2003 6.06047 10.2445C6.74645 10.3162 7.44558 10.5003 7.50892 11.3524ZM8.21402 11.975C7.89613 12.1782 7.53999 12.3407 7.14083 12.4638C7.07032 12.4889 6.98786 12.4925 6.91257 12.4769C6.67714 12.4255 6.51819 12.1913 6.56599 11.9499C6.70582 11.2735 6.47397 11.1934 5.96845 11.1337C5.09484 11.044 4.38973 10.5875 4.31325 9.62784C4.31325 9.58003 4.30727 9.53223 4.30727 9.47845C4.17342 9.63142 4.05989 9.8083 3.97025 10.0019C3.72168 10.5516 3.6906 11.2567 4.03359 11.7778C4.10291 11.8794 4.13876 12.0001 4.11606 12.1339C4.07184 12.3754 3.8364 12.5343 3.595 12.4937C3.06079 12.3957 2.61024 12.208 2.22542 11.963C0.841506 11.0691 0.463857 9.38643 0.749484 7.85791C0.88931 7.13966 1.16896 6.41902 1.58844 5.77367C2.57917 4.22483 2.90662 2.86482 2.47759 1.04708C2.4489 0.922795 2.47759 0.786554 2.55407 0.681386C2.69987 0.481806 2.97952 0.443563 3.17671 0.583389C4.7136 1.70199 5.52746 3.16957 4.94186 5.06259C4.82474 5.45697 4.92274 5.73901 5.10081 5.89437C5.17969 5.96369 5.27529 6.01269 5.38046 6.03778C5.47607 6.07244 5.58124 6.07244 5.67923 6.04735C5.87642 6.01269 6.06047 5.85733 6.11783 5.55258C6.39748 4.14835 6.50504 3.20422 7.90927 2.41307C7.99771 2.35571 8.11244 2.33659 8.22717 2.35332C8.46499 2.39515 8.62752 2.63536 8.58331 2.87796C8.37297 3.97984 8.55104 5.12952 9.15217 6.08917C9.86086 7.22331 10.1979 8.62755 9.79632 9.93617C9.54535 10.7512 9.02071 11.4671 8.21402 11.975Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2504_14923">
          <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
const CardArrowIconDisabled = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" fill="#F6F6F6" />
      <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="white" />
      <path
        d="M14.99 12.1302L10.02 7.13022C9.82 6.93022 9.5 6.93022 9.31 7.13022C9.11 7.33022 9.11 7.65022 9.31 7.84022L13.89 12.4502L9.15 17.1202C8.95 17.3202 8.95 17.6402 9.15 17.8302C9.35 18.0302 9.67 18.0302 9.87 17.8302L14.85 12.9202C15.06 12.7402 15.26 12.4202 14.99 12.1302Z"
        fill="#333333"
      />
    </svg>
  );
};
const CardArrowIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#3463FC" />
      <path
        d="M14.99 12.15L10.02 7.15C9.82 6.95 9.5 6.95 9.31 7.15C9.11 7.35 9.11 7.67 9.31 7.86L13.89 12.47L9.15 17.14C8.95 17.34 8.95 17.66 9.15 17.85C9.35 18.05 9.67 18.05 9.87 17.85L14.85 12.94C15.06 12.76 15.26 12.44 14.99 12.15Z"
        fill="white"
      />
    </svg>
  );
};
const ChatMessageAmazon = ({
  device,
  chatConfig,
  messageList,
  handleClickMessage,
  handleClickRate,
  uploadCancelToken,
  updateMessageScrollBarInfo,
  handleClickLikeBut,
  setMessageList,
  agentDisabled,
  setUploadCancelToken,
  setUploadProgress,
}) => {
  const ButtonArrow = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 12 13" fill="none">
      <path
        d="M11 6.50003C11 6.45003 11 6.35002 10.95 6.30002C10.9 6.05002 10.8 5.85003 10.6 5.70003L7.75 3.15002C7.55 2.95002 7.25 3.00002 7.1 3.20002C6.9 3.40002 6.95 3.70003 7.15 3.85003L9.55 6.00003H2.5C2.25 6.00003 2 6.20003 2 6.50003C2 6.80002 2.2 7.00003 2.5 7.00003H9.55L7.15 9.15003C6.95 9.35003 6.95 9.65002 7.1 9.80002C7.2 9.90002 7.3 9.95003 7.45 9.95003C7.55 9.95003 7.7 9.90003 7.75 9.85003L10.6 7.30002C10.8 7.15002 10.9 6.90002 10.95 6.70002C11 6.65002 11 6.55002 11 6.50003Z"
        fill="currentColor"
      />
    </svg>
  );
  const AudioIcon = () => (
    <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.4 9.1C1.4 9.4866 1.0866 9.8 0.7 9.8C0.313401 9.8 0 9.4866 0 9.1V4.9C0 4.5134 0.313401 4.2 0.7 4.2C1.0866 4.2 1.4 4.5134 1.4 4.9V9.1ZM18.2 4.9C18.2 4.5134 17.8866 4.2 17.5 4.2C17.1134 4.2 16.8 4.5134 16.8 4.9V9.1C16.8 9.4866 17.1134 9.8 17.5 9.8C17.8866 9.8 18.2 9.4866 18.2 9.1V4.9ZM5.6 3.5C5.6 3.1134 5.2866 2.8 4.9 2.8C4.5134 2.8 4.2 3.1134 4.2 3.5V10.5C4.2 10.8866 4.5134 11.2 4.9 11.2C5.2866 11.2 5.6 10.8866 5.6 10.5V3.5ZM14 3.5C14 3.1134 13.6866 2.8 13.3 2.8C12.9134 2.8 12.6 3.1134 12.6 3.5V10.5C12.6 10.8866 12.9134 11.2 13.3 11.2C13.6866 11.2 14 10.8866 14 10.5V3.5ZM9.8 0.7C9.8 0.313401 9.4866 0 9.1 0C8.7134 0 8.4 0.313401 8.4 0.7V13.3C8.4 13.6866 8.7134 14 9.1 14C9.4866 14 9.8 13.6866 9.8 13.3V0.7Z"
        fill={chatConfig.chatThemeColor}
      />
    </svg>
  );
  // 消息bodyRef
  const messageBodyRef = useRef(null);
  let [showGif, setShowGif] = useState(false);

  // const linkAttributePlugin = [[remarkLinkAttributes, { target: '_blank' }]];
  const renderers = {
    link: ({ href, children }) => (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    ),
  };
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif'];
  const videoExtensions = ['.mp4', '.mov', '.avi'];
  const uploadMessage = useRef(null);
  // 处理页面销毁时，关闭资源
  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      // 遍历所有被观察的元素
      for (const entry of entries) {
        updateMessageScrollBarInfo();
      }
    });

    // 要观察变化的元素
    const targetElement = messageBodyRef.current;
    // 开始观察目标元素的尺寸变化
    observer.observe(targetElement);
  }, []);

  /**
   * 点击赞图标
   * @param item 消息数据
   * @param type 消息类型，0点击正赞，1点击倒赞
   */
  const handleClickLikeIcon = (item, type) => {
    handleClickLikeBut(item, type);
  };

  /**
   * 识别Message对象中的Type返回相应的标签
   * @param message 消息对象
   * @param index 消息下标
   * @returns {Element} 对应标签内容
   */
  const messageTypeAnalyzer = (message, index) => {
    if (message) {
      // 如果是回话事件消息
      if (message.dataType === messageDateType.EVENT) {
        return eventMessage(message, index);
      }
      // 如果是聊天内容消息
      if (message.dataType === messageDateType.MESSAGE) {
        // 知识库消息
        if (message.role === messageRole.KNOWLEDGE) {
          return knowledgeMessage(message, index);
        }
        // connect的坐席消息
        else if (message.role === messageRole.AGENT) {
          return agentMessage(message, index);
        }
        // 客户
        else if (message.role === messageRole.CUSTOMER) {
          // // 同步附件上传列表中的上传进度
          // const upload = uploadProgress.find(upload => upload.fileName === message.fileName);
          // // 如果找到匹配的fileName，则更新message对象的uploadProgress
          // if (upload) {
          //   message.uploadProgress = upload.progress;
          // }
          return customerMessage(message, index);
        } else if (message.role === messageRole.AIAGENT) {
          return aiAgentMessage(message, index);
        }
      }
      // 如果是满意度评价
      if (message.dataType === messageDateType.EVALUATION) {
        return evaluationMessage(message, index);
      }
      // 如果是分割线
      if (message.dataType === messageDateType.DIVIDER) {
        return dividerMessage(message, index);
      }
    } else {
      return knowledgeMessage(message, index);
    }
  };
  function dividerMessage(message, index) {
    return (
      // <Divider plain key={index}>
      //   {message.content}
      // </Divider>
      <div className="divider-message" style={{ fontSize: device == 'mobile' ? '0.8rem' : '0.8rem', margin: '0px 0' }}>
        {message.content}
      </div>
    );
  }

  const handleClickButton = (item, index, message) => {
    console.log('item', item);
    message.disabled = true;
    handleClickMessage(item, index);
  };

  const handleCancelUpload = (message) => {
    if (uploadCancelToken) {
      uploadCancelToken.cancel('用户取消上传');
    }
  };
  const onFinish = (values, message) => {
    let arr = [];
    // for (let key in message?.data?.complexData?.formList) {
    //   arr.push({
    //     variablesKey: key,
    //     value: values[key],

    //   });
    // }
    message?.data?.complexData?.formList.forEach((ele) => {
      arr.push({
        variablesKey: ele.variablesKey,
        value: ele.value || '',
        valueName: ele.formName,
        attributeType: ele.attributeType,
        attributeValues: ele.attributeValues,
      });
    });
    let obj = {
      operate: 'submit',
      formList: arr,
    };
    handleClickMessage({
      content: JSON.stringify(obj),
      type: 'form',
    });
    message.disabled = true;
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  /**
   * 回话消息
   * @param message
   * @param index
   * @returns {Element}
   */
  function eventMessage(message, index) {
    return (
      <ChatMessageEvent key={index} $device={device} $chatservicecolor={chatConfig.chatServiceColor}>
        <span>{message.content}</span>
      </ChatMessageEvent>
    );
  }

  /**
   * 知识库消息
   * @param message
   * @param index
   */
  function knowledgeMessage(message, index) {
    return (
      <ChatMessageAgentWrapper key={index}>
        {message ? (
          <CSSTransition in={true} appear={true} timeout={3000} classNames="message">
            <div className="messageDiv">
              <AgentInfo $device={device}>
                {chatConfig.chatRobotIcon ? (
                  <img src={chatConfig.chatRobotIcon} alt="" />
                ) : (
                  agent(chatConfig.chatThemeColor)
                )}
                <span>{message.displayName}</span>
                {/* <span className="messageTime">{message.time}</span> */}
              </AgentInfo>
              <AgentContentWrapper $device={device}>
                {message.contentType === 'image' ? (
                  <ContentImage
                    $chatservicecolor={chatConfig.chatServiceColor}
                    $chatmessagecolor={chatConfig.chatMessageColor}
                  >
                    <Image src={message.content} />
                  </ContentImage>
                ) : message.contentType === 'video' ? (
                  <ContentVideo
                    $chatservicecolor={chatConfig.chatServiceColor}
                    $chatmessagecolor={chatConfig.chatMessageColor}
                  >
                    <video
                      src={message.content}
                      controls
                      style={{ width: '100%' }}
                      controlsList="nodownload"
                      playsInline
                    ></video>
                  </ContentVideo>
                ) : message.contentType === 'link' ? (
                  <AgentContent
                    $device={device}
                    $chatservicecolor={chatConfig.chatServiceColor}
                    $chatmessagecolor={chatConfig.chatMessageColor}
                  >
                    <a href={message.content}>{message.fileName}</a>
                  </AgentContent>
                ) : (
                  <AgentContent
                    $device={device}
                    $chatservicecolor={chatConfig.chatServiceColor}
                    $chatmessagecolor={chatConfig.chatMessageColor}
                  >
                    <ReactMarkdown components={{ a: LinkRenderer, img: ImgRenderer }}>{message.content}</ReactMarkdown>
                    {message.isShowLikeBut ? (
                      <LikeButContainer>
                        <span
                          onClick={() => {
                            handleClickLikeIcon(message, 1);
                          }}
                        >
                          {message.likeStatus === 1 ? zanBrightIcon('#3463FC') : zanDarkIcon('#999999')}
                        </span>
                        <span></span>
                        <span
                          onClick={() => {
                            handleClickLikeIcon(message, 2);
                          }}
                        >
                          {message.likeStatus === 2 ? zanBrightIcon('#F22417') : zanDarkIcon('#999999')}
                        </span>
                      </LikeButContainer>
                    ) : (
                      ''
                    )}
                  </AgentContent>
                )}
              </AgentContentWrapper>
              {message.list?.length > 0 ? (
                <AgentList $device={device} $chatmessagecolor={chatConfig.chatMessageColor}>
                  {message.list.map((item, index1) => {
                    if (!item?.name || item?.name == '' || item?.name == undefined || item?.name == null) {
                      return '';
                    } else {
                      return (
                        <ListItem
                          $device={device}
                          key={index1 + 1000}
                          onClick={() => {
                            handleClickButton(item, index);
                          }}
                          $chatservicecolor={chatConfig.chatServiceColor}
                          $chatmessagecolor={chatConfig.chatMessageColor}
                        >
                          {item.name}
                        </ListItem>
                      );
                    }
                  })}
                </AgentList>
              ) : (
                ''
              )}
            </div>
          </CSSTransition>
        ) : (
          <ChatMessageAgentWrapper>
            <AgentInfo $device={device}>
              {chatConfig.chatRobotIcon ? (
                <img src={chatConfig.chatRobotIcon} alt="" />
              ) : (
                agent(chatConfig.chatThemeColor)
              )}
              <span>{message.displayName}</span>
            </AgentInfo>

            <AgentContentWrapper $device={device}>
              <AgentContent
                $device={device}
                $chatservicecolor={chatConfig.chatServiceColor}
                $chatmessagecolor={chatConfig.chatMessageColor}
              >
                <Spinner $chatmessagecolor={chatConfig.chatMessageColor}>
                  <span></span>
                  <span></span>
                  <span></span>
                </Spinner>
              </AgentContent>
            </AgentContentWrapper>
          </ChatMessageAgentWrapper>
        )}
      </ChatMessageAgentWrapper>
    );
  }

  /**
   * connect坐席消息
   * @param message
   * @param index
   */
  function agentMessage(message, index) {
    let avatar = localStorage.getItem('imChatAvatar');
    if (avatar) {
      avatar = JSON.parse(avatar);
    }
    let avatarUrl = avatar?.find((item) => item.uid === message.uid)?.avatar;

    return (
      <CSSTransition in={true} appear={true} timeout={300} classNames="message" key={index}>
        <ChatMessageAgentWrapper>
          <AgentInfo $device={device}>
            {avatarUrl ? <img style={{ borderRadius: 50 }} src={avatarUrl} alt="" /> : agent(chatConfig.chatThemeColor)}
            <span>{message.displayName}</span>
            {/* <span className="messageTime">{message.time}</span> */}
          </AgentInfo>

          <AgentContentWrapper $device={device}>
            {message.contentType === 'image' ? (
              <ContentImage
                $chatservicecolor={chatConfig.chatServiceColor}
                $chatmessagecolor={chatConfig.chatMessageColor}
              >
                <Image src={message.content} />
              </ContentImage>
            ) : message.contentType === 'video' ? (
              <ContentVideo
                $chatservicecolor={chatConfig.chatServiceColor}
                $chatmessagecolor={chatConfig.chatMessageColor}
              >
                <video
                  src={message.content}
                  controls
                  style={{ width: '100%' }}
                  controlsList="nodownload"
                  playsInline
                ></video>
              </ContentVideo>
            ) : message.contentType === 'link' ? (
              <AgentContent
                $device={device}
                $chatservicecolor={chatConfig.chatServiceColor}
                $chatmessagecolor={chatConfig.chatMessageColor}
              >
                <a href={message.content}>{message.fileName}</a>
              </AgentContent>
            ) : (
              <AgentContent
                $device={device}
                $chatservicecolor={chatConfig.chatServiceColor}
                $chatmessagecolor={chatConfig.chatMessageColor}
              >
                <ReactMarkdown components={{ a: LinkRenderer, img: ImgRenderer }}>{message.content}</ReactMarkdown>
              </AgentContent>
            )}
          </AgentContentWrapper>
          {message.extra && message.extra.referenceMessage && message.extra.referenceMessage.referenceContent && (
            <AgentContentWrapper $device={device}>
              {message.extra.referenceMessage.referenceContentType === 'text' ? (
                message.extra.referenceMessage.isRecall ? (
                  <MessageQuote>{chatConfig.isRecallMsg}</MessageQuote>
                ) : (
                  <MessageQuote>
                    {message.extra.referenceMessage.referenceReplyPerson +
                      message.extra.referenceMessage.referenceReplyPerson !=
                    ''
                      ? ':'
                      : ''}

                    {message.extra.referenceMessage.referenceContent}
                  </MessageQuote>
                )
              ) : message.extra.referenceMessage.referenceContentType === 'image' ? (
                message.extra.referenceMessage.isRecall ? (
                  <MessageQuote>{chatConfig.isRecallMsg}</MessageQuote>
                ) : (
                  <MessageQuote>
                    <span style={{ whiteSpace: 'nowrap' }}>{message.extra.referenceMessage.referenceReplyPerson}:</span>
                    <Image
                      src={
                        message.extra.referenceMessage.referenceContentFile ||
                        message.extra.referenceMessage.referenceContent
                      }
                      style={{ width: '100px' }}
                      alt=""
                    />
                  </MessageQuote>
                )
              ) : message.extra.referenceMessage.isRecall ? (
                <MessageQuote>{chatConfig.isRecallMsg}</MessageQuote>
              ) : (
                <MessageQuote>
                  {message.extra.referenceMessage.referenceReplyPerson +
                    message.extra.referenceMessage.referenceReplyPerson !=
                  ''
                    ? ':'
                    : ''}
                  <a href={message.extra.referenceMessage.referenceContent}>
                    {message.extra.referenceMessage.referenceContent}
                  </a>
                </MessageQuote>
              )}
            </AgentContentWrapper>
          )}
        </ChatMessageAgentWrapper>
      </CSSTransition>
    );
  }

  /**
   * 客户消息
   * @param message
   * @param index
   */
  function customerMessage(message, index) {
    // console.log(message);
    // return
    // console.log(chatConfig);
    let showEndCustomerName = chatConfig.showEndCustomerName;
    // if (message.displayName == '匿名' && !showEndCustomerName) {
    //   showEndCustomerName = false;
    // }
    return (
      <ChatMessageCustomerWrapper key={index}>
        <CustomerInfo $device={device}>
          {showEndCustomerName && <span>{message.displayName}</span>}
          {/*<img src={customer} alt="" />*/}
          <img src={chatConfig.chatUserIcon || customer} alt="" />
        </CustomerInfo>

        <CustomerContentWrapper $device={device}>
          {(message.contentType === 'image' || message.contentType === 'video' || message.contentType === 'link') &&
          message.uploadStatus !== 'none' ? (
            message.uploadStatus === 'active' ? (
              <UploadContainer key={index}>
                <LeftWrapper
                  $themecolor={chatConfig.chatThemeColor}
                  $chatservicecolor={chatConfig.chatServiceColor}
                  $chatmessagecolor={chatConfig.chatMessageColor}
                  onClick={handleCancelUpload}
                >
                  <img src={close} alt="" />
                </LeftWrapper>
                <RightWrapper>
                  <Progress
                    type="circle"
                    percent={message.uploadProgress}
                    status={message.uploadStatus}
                    strokeColor={chatConfig.chatThemeColor}
                    size={80}
                  />
                  <FileUploading>{message.fileName}</FileUploading>
                </RightWrapper>
              </UploadContainer>
            ) : (
              <UploadContainer key={index}>
                <RightWrapper>
                  <Progress
                    type="circle"
                    percent={message.uploadProgress}
                    status={message.uploadStatus}
                    strokeColor={chatConfig.chatThemeColor}
                    size={80}
                  />
                  <FileUploading>{message.fileName}</FileUploading>
                </RightWrapper>
              </UploadContainer>
            )
          ) : message.contentType === 'image' ? (
            <ContentImage
              $chatservicecolor={chatConfig.chatServiceColor}
              $chatmessagecolor={chatConfig.chatMessageColor}
            >
              <Image src={message.content} />
            </ContentImage>
          ) : message.contentType === 'video' ? (
            <ContentVideo
              $chatservicecolor={chatConfig.chatServiceColor}
              $chatmessagecolor={chatConfig.chatMessageColor}
            >
              <video
                src={message.content}
                controls
                style={{ width: '100%' }}
                controlsList="nodownload"
                playsInline
              ></video>
            </ContentVideo>
          ) : message.contentType === 'link' ? (
            <CustomerContent
              $userFontColor={chatConfig.userFontColor}
              $device={device}
              $chatservicecolor={chatConfig.chatServiceColor}
              $chatmessagecolor={chatConfig.chatMessageColor}
              $showEndCustomerName={showEndCustomerName}
            >
              <a href={message.content}>{message.fileName}</a>
            </CustomerContent>
          ) : message.contentType === 'card1' ? (
            <CustomerContent
              $userFontColor={chatConfig.userFontColor}
              $device={device}
              $chatservicecolor={chatConfig.chatServiceColor}
              $chatmessagecolor={chatConfig.chatMessageColor}
              $showEndCustomerName={showEndCustomerName}
              style={{
                width: '100%',
                height: '100%',
                maxWidth: JSON.parse(message.content)?.cardLayout == 1 && device == 'pc' ? '220px' : '80%',
                minWidth: JSON.parse(message.content)?.cardLayout == 1 && device == 'pc' ? '220px' : '80%',
                padding: '5px 5px',
                boxSizing: 'border-box',
              }}
            >
              <div
                className="live_MessageCardDiv"
                style={{
                  background: '#f9f9f9',
                  borderRadius: '4px',
                  boxSizing: 'border-box',
                  padding: '10px',
                }}
              >
                <div
                  className="MessageCardDiv_img"
                  style={{
                    width: '100%',
                    height: '220px',
                    maxHeight: '220px',
                    minHeight: '220px',
                    maxWidth: '100%',
                    minWidth: '100%',
                    margin: device == 'mobile' ? '0 0 12px 0px' : '0px 0 10px 0',
                  }}
                >
                  <img src={JSON.parse(message.content).cardImageUrl} />
                </div>
                <div className="MessageCardDiv_title">
                  <span style={{ fontSize: device == 'mobile' ? '1.17rem' : '1rem' }}>
                    {JSON.parse(message.content).cardTitle}
                  </span>
                </div>
                <div className="MessageCardDiv_content">
                  <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                    <span style={{ color: '#ff1e1e' }}>{JSON.parse(message.content).cardPrice}</span>
                    {JSON.parse(message.content).cardNumber && (
                      <div style={{ color: '#999', fontSize: '12px' }}>
                        &nbsp;&nbsp;x{JSON.parse(message.content).cardNumber}
                      </div>
                    )}
                  </div>
                  <div>
                    <span style={{ color: '#FFA601' }}>{JSON.parse(message.content).cardStatus}</span>
                  </div>
                </div>
              </div>
            </CustomerContent>
          ) : message.contentType === 'card2' ? (
            <CustomerContent
              $userFontColor={chatConfig.userFontColor}
              $device={device}
              $chatservicecolor={chatConfig.chatServiceColor}
              $chatmessagecolor={chatConfig.chatMessageColor}
              $showEndCustomerName={showEndCustomerName}
              style={{
                width: '100%',
                height: '100%',
                maxWidth: '400px',
                padding: '5px 5px',
                boxSizing: 'border-box',
              }}
            >
              <div className="live_MessageCardDiv2" style={{ marginBottom: 0, width: '100%' }}>
                <div className="MessageCardDiv2_img">
                  <img
                    style={{
                      width: '70px',
                      height: '70px',
                      // border: '1px solid blue',
                    }}
                    src={JSON.parse(message.content).cardImageUrl}
                    alt=""
                  />
                </div>
                <div style={{ width: 'calc(100% - 70px)', padding: '5px', boxSizing: 'border-box' }}>
                  <div className="MessageCardDiv2_title">
                    <div className="MessageCardDiv2_title_text">
                      <span>{JSON.parse(message.content).cardTitle}</span>
                    </div>
                    <div className="MessageCardDiv2_title_price">
                      <div>
                        <span>{JSON.parse(message.content).cardPrice}</span>
                      </div>
                      <div>
                        {JSON.parse(message.content).cardNumber ? 'x' + JSON.parse(message.content).cardNumber : ''}
                      </div>
                    </div>
                  </div>
                  <div className="MessageCardDiv2_status">
                    <span>{JSON.parse(message.content).cardStatus}</span>
                  </div>
                </div>
              </div>
            </CustomerContent>
          ) : message.contentType === 'audio' && message.content == '' ? (
            <div>
              <CustomerMessageWarpper>
                <CustomerContent
                  $userFontColor={chatConfig.userFontColor}
                  $device={device}
                  $chatservicecolor={chatConfig.chatServiceColor}
                  $chatmessagecolor={chatConfig.chatMessageColor}
                  $showEndCustomerName={showEndCustomerName}
                >
                  <div className="loaderVideo">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                  </div>
                  {/* <ReactMarkdown components={{ a: LinkRenderer, img: ImgRenderer }}>{message.content}</ReactMarkdown> */}
                </CustomerContent>
              </CustomerMessageWarpper>
              <CustomerContentFooter>{message.messageStatus}</CustomerContentFooter>
            </div>
          ) : message.duration != undefined &&
            message.duration != null &&
            message.duration.length > 0 &&
            message.content != '' ? (
            <div>
              <CustomerMessageWarpper>
                <CustomerContent
                  $userFontColor={chatConfig.userFontColor}
                  $device={device}
                  $chatservicecolor={chatConfig.chatServiceColor}
                  $chatmessagecolor={chatConfig.chatMessageColor}
                  $showEndCustomerName={showEndCustomerName}
                >
                  <ReactMarkdown components={{ a: LinkRenderer, img: ImgRenderer }}>{message.content}</ReactMarkdown>
                </CustomerContent>
              </CustomerMessageWarpper>
              <div className="audioFooter">
                <AudioIcon />
                <span>{message.duration || ''}</span>
              </div>
              <CustomerContentFooter>{message.messageStatus}</CustomerContentFooter>
            </div>
          ) : (
            <div>
              {message.duration}
              <CustomerMessageWarpper>
                <CustomerContent
                  $userFontColor={chatConfig.userFontColor}
                  $device={device}
                  $chatservicecolor={chatConfig.chatServiceColor}
                  $chatmessagecolor={chatConfig.chatMessageColor}
                  $showEndCustomerName={showEndCustomerName}
                >
                  <ReactMarkdown components={{ a: LinkRenderer, img: ImgRenderer }}>{message.content}</ReactMarkdown>
                </CustomerContent>
              </CustomerMessageWarpper>
              <CustomerContentFooter>{message.messageStatus}</CustomerContentFooter>
            </div>
          )}
          {/* {JSON.stringify(message)} */}
          {message.channel === 'IM_CHAT' && (
            <div style={{ display: 'inline-block', marginRight: 6 }}>
              {message.messageAckStatus === 'READ' ? <MsgReadedIcon /> : <MsgReadIcon />}
            </div>
          )}
        </CustomerContentWrapper>
        {/* <span
          className="messageTime"
          style={{
            marginRight: device == 'mobile' ? '40px' : '32px',
            marginTop: device == 'mobile' ? '-3px' : '-7px',
            textAlign: 'right',
          }}
        >
          {message.time}
        </span> */}
      </ChatMessageCustomerWrapper>
    );
  }
  const isImage = (fileName) => {
    const extension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
    return imageExtensions.includes(extension);
  };
  const handleFileUpload = async (event) => {
    const file = event.target.files[0]; // 获取上传的文件
    // 文件不能大于20mb
    if (file.size > 200 * 1024 * 1024) {
      console.log('文件不能大于200MB');
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    // 创建一个新的取消令牌
    const source = axios.CancelToken.source();
    setUploadCancelToken(source);
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const date = `${year}/${month}/${day}`;

    let cancel = false;
    // 预签名
    await getUploadPreSignedUrl(file.name, file.type, chatConfig.companyId, date).then(async (res) => {
      // 创建上传任务
      const upload = axios
        .put(res.data, file, {
          onUploadProgress: (progressEvent) => {
            let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            let progress = {
              fileName: file.name,
              progress: percentCompleted,
            };
            setUploadProgress((prevProgress) => {
              return [...prevProgress.filter((upload) => upload.fileName !== file.name), progress];
            });
          },
          cancelToken: source.token,
        })
        .catch(async () => {
          cancel = true;
        })
        .finally(async () => {
          setUploadCancelToken(null);
          if (!cancel) {
            // 获取预签名url，显示附件
            await getDownloadPreSignedUrl(file.name, file.type, chatConfig.companyId, date).then(async (res) => {
              if (res.code === 200) {
                // console.log(uploadMessage.current);
                // 先判断uploadMessage.current.value是不是数组
                let obj = {
                  fileName: file.name,
                  path: res.data,
                };
                if (Array.isArray(uploadMessage.current.value)) {
                  uploadMessage.current.value.push(obj);
                } else {
                  uploadMessage.current.value = [obj];
                }
                // 更新messageList中匹配的元素
                // console.log(messageList);
                // console.log(uploadMessage.current);
                setMessageList((prevList) => {
                  let arr = [...prevList];
                  arr.map((m) => {
                    if (m.time === uploadMessage.current.msgTime) {
                      // console.log(m);
                      let arr1 = m.data?.complexData?.formList;
                      if (arr1) {
                        arr1.find((e) => e.attributeName == uploadMessage.current.obj.attributeName).value.push(obj);
                      }
                      return { ...m };
                    }
                    return m;
                  });
                  // console.log('arr', arr);
                  return arr;
                });

                // setMessageList((prevList) => {
                //   let arr = [...prevList];
                //   arr.map((m) => {
                //     if (m.aiagentType === uploadMessage.current.aiagentType && m.time === uploadMessage.current.time) {
                //       console.log(m);
                //       let obj = m;
                //       obj.data.complexData.formList.find((e) => e.attributeName == uploadMessage.current.data.complexData.formList[0].attributeName).value.push(obj);
                //       return { ...m, ...uploadMessage.current };
                //     }
                //     return m;
                //   });
                //   return arr;
                // });
              }
            });
          }
        });
    });
  };
  // aiagent消息
  function aiAgentMessage(message, index) {
    return (
      <CSSTransition in={true} appear={true} timeout={300} key={index}>
        {message ? (
          <ChatMessageAgentWrapper>
            <AgentInfo $device={device}>
              {chatConfig.chatRobotIcon ? (
                <img style={{ borderRadius: 50 }} src={chatConfig.chatRobotIcon} alt="" />
              ) : (
                agent(chatConfig.chatThemeColor)
              )}
              <span>{message.displayName}</span>
            </AgentInfo>
            <AgentContentWrapper $device={device}>
              {message.contentType === 'Image' ? (
                <AgentContent>
                  <div>{message.content}</div>
                  <ContentImage
                    $chatservicecolor={chatConfig.chatServiceColor}
                    $chatmessagecolor={chatConfig.chatMessageColor}
                  >
                    <Image src={message.data?.attachments[0].url} />
                  </ContentImage>
                </AgentContent>
              ) : message.contentType === 'Video' ? (
                <AgentContent>
                  <div>{message.content}</div>
                  <ContentVideo
                    $chatservicecolor={chatConfig.chatServiceColor}
                    $chatmessagecolor={chatConfig.chatMessageColor}
                  >
                    <video
                      src={message.data?.attachments[0].url}
                      controls
                      style={{ width: '100%' }}
                      controlsList="nodownload"
                      playsInline
                    ></video>
                  </ContentVideo>
                </AgentContent>
              ) : message?.data?.contentType === 'Attachment' ? (
                <AgentContent
                  $device={device}
                  $chatservicecolor={chatConfig.chatServiceColor}
                  $chatmessagecolor={chatConfig.chatMessageColor}
                >
                  <span>{message.content}</span>
                  <div className="fileDiv">
                    <DocIcon></DocIcon>
                    <Tooltip placement="top" title={message.data.attachments[0].fileName}>
                      <span
                        onClick={() => {
                          window.open(message.data.attachments[0].url);
                        }}
                      >
                        {message.data.attachments[0].fileName}
                      </span>
                    </Tooltip>
                  </div>
                  <a href={message.data.attachments[0].url}>{message.data.attachments[0].fileName}</a>
                </AgentContent>
              ) : message.aiagentType === 'Form' ? (
                <AgentContent
                  $device={device}
                  $chatservicecolor={chatConfig.chatServiceColor}
                  $chatmessagecolor={chatConfig.chatMessageColor}
                  style={{ width: '100%' }}
                >
                  <Form
                    name="basic"
                    style={{
                      minWidth: '200px',
                      width: '100%',
                    }}
                    initialValues={{
                      remember: true,
                    }}
                    onFinish={(value) => {
                      setMessageList((prevList) => {
                        let arr = [...prevList];
                        arr.map((m) => {
                          if (m.msgId === message.msgId) {
                            return { ...m, disabled: true };
                          }
                          return m;
                        });
                        return arr;
                      });
                      onFinish(value, message);
                    }}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    layout="vertical"
                    colon={false}
                    requiredMark={false}
                    disabled={message.disabled}
                  >
                    {message &&
                      message?.data?.complexData?.formList &&
                      message?.data?.complexData?.formList.map((e) => {
                        return (
                          <Form.Item
                            label={
                              <span style={{ fontSize: 14 }}>
                                {e.formName}
                                {e.required == 1 ? <sup style={{ color: 'red' }}>*</sup> : ''}
                              </span>
                            }
                            style={{ marginBottom: message.disabled ? '-10px' : '0px' }}
                            name={e.attributeName || e.variablesKey}
                            colon={false}
                            requiredMark={false}
                            rules={[
                              {
                                validator: () => {
                                  if (e.required == 1) {
                                    if (e.attributeType == 1 || e.attributeType == 2) {
                                      return new Promise((resolve, reject) => {
                                        if (e.value) {
                                          let reg = new RegExp(e.regexPattern);
                                          if (reg.test(e.value)) {
                                            resolve();
                                          } else {
                                            reject(new Error(''));
                                          }
                                        } else {
                                          reject(new Error(''));
                                        }
                                      });
                                    } else if (e.attributeType != 11) {
                                      return new Promise((resolve, reject) => {
                                        if (e.value) {
                                          resolve();
                                        } else {
                                          reject(new Error(''));
                                        }
                                      });
                                    } else {
                                      return new Promise((resolve, reject) => {
                                        if (Array.isArray(e.value) && e.value.length > 0) {
                                          resolve();
                                        } else {
                                          reject(new Error(''));
                                        }
                                      });
                                    }
                                  } else {
                                    return Promise.resolve();
                                  }
                                },
                              },
                            ]}
                          >
                            {message.disabled ? (
                              e.attributeType == 11 ? (
                                e.value.map((item) => {
                                  return (
                                    <div className="fileDiv" style={{ position: 'relative', marginBottom: 5 }}>
                                      <DocIcon></DocIcon>
                                      <Tooltip placement="top" title={item.fileName}>
                                        <span
                                          onClick={() => {
                                            window.open(item.path);
                                          }}
                                        >
                                          {item.fileName}
                                        </span>
                                      </Tooltip>
                                    </div>
                                  );
                                })
                              ) : (
                                <span
                                  style={{
                                    display: 'block',
                                    width: '100%',
                                    marginTop: '-10px',
                                    lineHeight: '20px',
                                    wordBreak: 'break-all',
                                  }}
                                >
                                  {e.attributeType == 3 || e.attributeType == 5
                                    ? e.attributeValues.find((ele) => ele.value == e.value)?.name || '-'
                                    : e.attributeType == 4 || e.attributeType == 6
                                    ? e.attributeValues
                                        .filter((ele) => e.value?.find((item) => item == ele.value))
                                        .map((ele) => ele.name)
                                        .join(',') || '-'
                                    : e.attributeType == 9 || e.attributeType == 10
                                    ? e.value?.join(' - ') || '-'
                                    : e.value || '-'}
                                </span>
                              )
                            ) : e.attributeType == 2 ? (
                              <TextArea
                                style={{ width: '100%' }}
                                placeholder={e.inputTip}
                                onChange={(input) => {
                                  let str = input.target.value;
                                  e.value = str;
                                }}
                              />
                            ) : e.attributeType == 3 ? (
                              <Select
                                style={{ width: '100%' }}
                                placeholder={e.inputTip}
                                onChange={(value) => {
                                  e.value = value;
                                }}
                                options={e.attributeValues.map((ele) => {
                                  return {
                                    label: ele.name,
                                    value: ele.value,
                                  };
                                })}
                              />
                            ) : e.attributeType == 4 ? (
                              <Select
                                mode="multiple"
                                style={{ width: '100%' }}
                                placeholder={e.inputTip}
                                onChange={(value) => {
                                  e.value = value;
                                }}
                                options={e.attributeValues.map((ele) => {
                                  return {
                                    label: ele.name,
                                    value: ele.value,
                                  };
                                })}
                              ></Select>
                            ) : e.attributeType == 5 ? (
                              <Radio.Group
                                style={{ width: '100%' }}
                                placeholder={e.inputTip}
                                onChange={(value) => {
                                  e.value = value.target.value;
                                }}
                              >
                                {e.attributeValues.map((ele) => {
                                  return <Radio value={ele.value}>{ele.name}</Radio>;
                                })}
                              </Radio.Group>
                            ) : e.attributeType == 6 ? (
                              <Checkbox.Group
                                style={{ width: '100%' }}
                                placeholder={e.inputTip}
                                onChange={(value) => {
                                  e.value = value;
                                }}
                              >
                                <div style={{ display: 'flex', flexDirection: 'column', flexWrap: 'nowrap' }}>
                                  {e.attributeValues.map((ele) => {
                                    return (
                                      <Checkbox value={ele.value}>
                                        <span>{ele.name}</span>
                                      </Checkbox>
                                    );
                                  })}
                                </div>
                              </Checkbox.Group>
                            ) : e.attributeType == 7 ? (
                              <DatePicker
                                format="YYYY-MM-DD"
                                style={{ width: '100%' }}
                                placeholder={e.inputTip}
                                onChange={(value, str) => {
                                  e.value = str;
                                }}
                              ></DatePicker>
                            ) : e.attributeType == 8 ? (
                              <DatePicker
                                style={{ width: '100%' }}
                                showTime
                                placeholder={e.inputTip}
                                onChange={(value, str) => {
                                  e.value = str;
                                }}
                              ></DatePicker>
                            ) : e.attributeType == 9 ? (
                              <RangePicker
                                format="YYYY-MM-DD"
                                style={{ width: '100%' }}
                                onChange={(value, str) => {
                                  e.value = str;
                                }}
                              ></RangePicker>
                            ) : e.attributeType == 10 ? (
                              <RangePicker
                                showTime
                                style={{ width: '100%' }}
                                onChange={(value, str) => {
                                  e.value = str;
                                }}
                              ></RangePicker>
                            ) : e.attributeType == 11 ? (
                              //这个显示文件的div在e.value发生改变之后并不会渲染，所以需要使用key来强制渲染
                              <div style={{ fontSize: 12, color: '#999' }}>
                                <span>
                                  {chatConfig.uploadFileTips.replace('{$fileNum}', 5).replace('{$fileSize}', 20)}
                                </span>
                                <div style={{ display: 'flex', flexDirection: 'column', flexWrap: 'nowrap' }}>
                                  {Array.isArray(e.value) &&
                                    e.value.map((item, index) => (
                                      <div className="fileDiv" style={{ position: 'relative', marginBottom: 5 }}>
                                        <DocIcon></DocIcon>
                                        <Tooltip placement="top" title={item.fileName}>
                                          <span
                                            onClick={() => {
                                              window.open(item.path);
                                            }}
                                          >
                                            {item.fileName}
                                          </span>
                                        </Tooltip>
                                        <DeleteOutlined
                                          onClick={() => {
                                            // console.log(item);
                                            //删除e.value中index位置的文件,并可以带动渲染
                                            e.value = e.value.filter((ele, index1) => index1 !== index);
                                            setMessageList((prevList) =>
                                              prevList.map((m) => (m.msgId === message.msgId ? { ...m } : m))
                                            );
                                          }}
                                          style={{
                                            display: 'block',
                                            color: 'red',
                                            position: 'absolute',
                                            right: 10,
                                            width: 15,
                                            height: 15,
                                            cursor: 'pointer',
                                          }}
                                        />
                                      </div>
                                    ))}
                                </div>
                                {Array.isArray(e.value) && e.value.length < 5 && (
                                  <div
                                    style={{
                                      color: '#3463FC',
                                      marginTop: 5,
                                      cursor: 'pointer',
                                    }}
                                  >
                                    <UploadOutlined style={{ marginRight: 5, color: '#3463FC' }} />
                                    <span
                                      onClick={() => {
                                        uploadMessage.current = {
                                          msgTime: message.time,
                                          obj: e,
                                        };
                                        const fileInput = document.createElement('input');
                                        fileInput.type = 'file';
                                        document.body.appendChild(fileInput);
                                        fileInput.click();
                                        fileInput.addEventListener('change', handleFileUpload);
                                        fileInput.remove();
                                      }}
                                    >
                                      {chatConfig.uploadFileClick}
                                    </span>
                                  </div>
                                )}
                              </div>
                            ) : (
                              <Input
                                style={{ width: '100%' }}
                                placeholder={e.inputTip}
                                onChange={(input) => {
                                  let str = input.target.value;
                                  e.value = str;
                                }}
                              />
                            )}
                          </Form.Item>
                        );
                      })}
                    {message.disabled ? (
                      <div style={{ height: '10px', width: '100%' }}></div>
                    ) : (
                      <Form.Item label={null}>
                        {agentDisabled && (
                          <div className="canvasFlow_liveChat_messageDiv_questionForm_button">
                            <Button
                              size="small"
                              htmlType="button"
                              style={{ marginRight: '10px' }}
                              disabled={message.disabled}
                              onClick={() => {
                                let obj = {
                                  operate: 'cancle',
                                };
                                setMessageList((prevList) =>
                                  prevList.map((m) => (m.msgId === message.msgId ? { ...m, disabled: true } : m))
                                );
                                handleClickMessage({
                                  content: JSON.stringify(obj),
                                  type: 'form',
                                });
                              }}
                            >
                              {chatConfig.buttonCancel || '取消'}
                            </Button>
                            <Button size="small" type="primary" htmlType="submit" disabled={message.disabled}>
                              {chatConfig.buttonConfirm || '提交'}
                            </Button>
                          </div>
                        )}
                      </Form.Item>
                    )}
                  </Form>
                </AgentContent>
              ) : message.aiagentType === 'hotIssue' ? (
                <AgentContent
                  $device={device}
                  $chatservicecolor={chatConfig.chatServiceColor}
                  $chatmessagecolor={chatConfig.chatMessageColor}
                  style={{ width: '100%', padding: '10px 10px' }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: 10 }}>
                    {HotIssusIcon(chatConfig.chatMessageColor)}
                    <span style={{ fontWeight: 'bold' }}>{chatConfig.hotQuestion}</span>
                  </div>
                  {/* <span>{JSON.stringify(message)}</span> */}
                  {message.content?.configType == 1 ? (
                    // 手动
                    <div style={{ width: '100%' }}>
                      {message?.content?.showType == 2 ? (
                        <div style={{ width: '100%' }}>
                          {message?.content?.issues?.map((ele) => {
                            return (
                              <div
                                className="hotIssuetype1"
                                onClick={(e) => {
                                  setMessageList((prevList) => {
                                    return prevList.map((msg) => {
                                      if (msg.msgId === message.msgId) {
                                        return {
                                          ...msg,
                                          content: {
                                            ...msg.content,
                                            issues: msg.content.issues.map((issue) => {
                                              if (issue.issueName === ele.issueName) {
                                                return {
                                                  ...issue,
                                                  open: !issue.open,
                                                };
                                              }
                                              return issue;
                                            }),
                                          },
                                        };
                                      }
                                      return msg;
                                    });
                                  });
                                }}
                              >
                                <span style={{ fontWeight: 'bold' }}>
                                  {ele.issueName}
                                  <RightOutlined
                                    style={{
                                      transform: ele.open ? 'rotate(90deg)' : 'rotate(0deg)',
                                      transition: 'all 0.3s ease',
                                    }}
                                  />
                                </span>
                                {ele.open && (
                                  <div className="hotIssuetype1_content">
                                    {ele.issueContents?.map((el) => {
                                      return (
                                        <div
                                          className="hotIssuetype1_content_item"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleClickButton({ content: el }, 0, message);
                                          }}
                                        >
                                          <div>{el}</div>
                                          <ArrowRightOutlined />
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <div>
                          <Tabs
                            tabBarGutter={10}
                            cardHeight={30}
                            size="small"
                            defaultActiveKey={message?.content?.issues[0]?.issueName}
                            items={message?.content?.issues?.map((ele) => {
                              return {
                                label: ele.issueName,
                                key: ele.issueName,
                                children: ele.issueContents?.map((ele, index) => {
                                  return (
                                    <div
                                      className="hotIssuetype2"
                                      onMouseEnter={(e) => {
                                        e.target.style.color = chatConfig.chatMessageColor;
                                      }}
                                      onMouseLeave={(e) => {
                                        e.target.style.color = '#666';
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          width: '100%',
                                          borderBottom: '1px solid #e6e6e6',
                                          padding: '5px 0px',
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleClickButton({ content: ele }, 0, message);
                                        }}
                                      >
                                        <div
                                          onMouseEnter={(e) => {
                                            e.target.style.color = chatConfig.chatMessageColor;
                                          }}
                                          onMouseLeave={(e) => {
                                            e.target.style.color = '#666';
                                          }}
                                        >
                                          {index + 1}. {ele}
                                        </div>
                                        <div>
                                          <ArrowRightOutlined />
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }),
                              };
                            })}
                          ></Tabs>
                        </div>
                      )}
                    </div>
                  ) : (
                    // 自动热点
                    <div style={{ width: '100%' }}>
                      {message?.content?.issues[0]?.issueContents?.map((ele) => {
                        return (
                          <div
                            className="hotIssuetype1"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleClickButton({ content: ele }, 0, message);
                            }}
                          >
                            <span style={{ fontWeight: 'bold' }}>
                              {ele}
                              <RightOutlined
                                style={{
                                  transition: 'all 0.3s ease',
                                }}
                              />
                            </span>
                          </div>
                        );
                      })}
                    </div>
                    // 自动
                    // <div>
                    //   <FormattedMessage
                    //     id="ai.agent.nodes.MessageHotIssue.title9"
                    //     defaultValue="自动推荐"
                    //   ></FormattedMessage>
                    // </div>
                  )}
                </AgentContent>
              ) : message.aiagentType === 'card' ? (
                <AgentContent
                  $device={device}
                  $chatservicecolor={chatConfig.chatServiceColor}
                  $chatmessagecolor={chatConfig.chatMessageColor}
                  style={{
                    width: '100%',
                    height: '100%',
                    maxWidth:
                      message.content?.cardLayout == 1 && device == 'pc'
                        ? '220px'
                        : message.content?.cardLayout == 2
                        ? '100%'
                        : '100%',
                    minWidth:
                      message.content?.cardLayout == 1 && device == 'pc'
                        ? '220px'
                        : message.content?.cardLayout == 2
                        ? '100%'
                        : '100%',
                    padding: '10px 10px',
                  }}
                >
                  {/* <span>{JSON.stringify(message)}</span> */}
                  {message.content?.cardLayout == 1 ? (
                    <div className="live_MessageCardDiv">
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          if (message.disabled) {
                            return;
                          }
                          setMessageList((prevList) => {
                            return prevList.map((m) => {
                              if (m.msgId === message.msgId) {
                                return { ...m, disabled: true };
                              }
                              return m;
                            });
                          });
                          handleClickMessage({
                            type: 'card1',
                            content: JSON.stringify({ ...message.content.cardList[message.cardIndex], cardLayout: 1 }),
                          });
                        }}
                        style={{ fontSize: device == 'mobile' ? '1.17rem' : '1rem' }}
                      >
                        {message?.content?.botMessage}
                      </div>
                      <div
                        className="MessageCardDiv_img"
                        style={{
                          width: '100%',
                          height: '220px',
                          maxHeight: '220px',
                          minHeight: '220px',
                          maxWidth: '100%',
                          minWidth: '100%',
                          margin: device == 'mobile' ? '12px 0px' : '0px',
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (message.disabled) {
                            return;
                          }
                          setMessageList((prevList) => {
                            return prevList.map((m) => {
                              if (m.msgId === message.msgId) {
                                return { ...m, disabled: true };
                              }
                              return m;
                            });
                          });
                          handleClickMessage({
                            type: 'card1',
                            content: JSON.stringify({ ...message.content.cardList[message.cardIndex], cardLayout: 1 }),
                          });
                        }}
                      >
                        <img
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          src={message.content?.cardList[message?.cardIndex]?.cardImageUrl}
                        />
                      </div>
                      <div
                        className="MessageCardDiv_title"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (message.disabled) {
                            return;
                          }
                          setMessageList((prevList) => {
                            return prevList.map((m) => {
                              if (m.msgId === message.msgId) {
                                return { ...m, disabled: true };
                              }
                              return m;
                            });
                          });
                          handleClickMessage({
                            type: 'card1',
                            content: JSON.stringify({ ...message.content.cardList[message.cardIndex], cardLayout: 1 }),
                          });
                        }}
                      >
                        <span style={{ fontSize: device == 'mobile' ? '1.17rem' : '1rem' }}>
                          {message?.content?.cardList[message?.cardIndex]?.cardTitle}
                        </span>
                      </div>
                      <div className="MessageCardDiv_content">
                        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                          <span style={{ color: '#ff1e1e' }}>
                            {message?.content?.cardList[message?.cardIndex]?.cardPrice}
                          </span>
                          {message?.content?.cardList[message?.cardIndex]?.cardNumber && (
                            <div style={{ color: '#999', fontSize: '12px' }}>
                              &nbsp;&nbsp;x{message?.content?.cardList[message?.cardIndex]?.cardNumber}
                            </div>
                          )}
                        </div>
                        <div>
                          <span style={{ color: '#FFA601' }}>
                            {message?.content?.cardList[message?.cardIndex]?.cardStatus}
                          </span>
                        </div>
                      </div>
                      <div
                        className="MessageCardDiv_button"
                        style={{
                          marginTop: device == 'mobile' ? '10px' : '5px',
                          marginBottom: device == 'mobile' ? '10px' : '0px',
                        }}
                      >
                        <div style={{ color: '#999', display: 'flex', alignItems: 'flex-end' }}>
                          <span
                            style={{
                              display: 'inline-block',
                              fontSize: '1rem',
                            }}
                          >
                            {message?.cardIndex + 1}
                          </span>
                          <span style={{ fontSize: 12 }}>/{message?.content?.cardList?.length}</span>
                        </div>
                        <div
                          className="MessageCardDiv_button_icon"
                          style={{ marginRight: device == 'mobile' ? '5px' : '' }}
                        >
                          <div
                            className="MessageCardDiv_button_icon_item"
                            style={{
                              transform: 'rotate(180deg)' + (device == 'mobile' ? 'scale(1.5)' : 'scale(1)'),
                              marginRight: device == 'mobile' ? '20px' : '5px',
                            }}
                            onClick={() => {
                              if (message?.cardIndex + 1 == 1) {
                                return;
                              }
                              setMessageList((prevList) =>
                                prevList.map((msg) =>
                                  msg === message
                                    ? {
                                        ...msg,
                                        cardIndex:
                                          msg.cardIndex - 1 < 0
                                            ? msg?.content?.cardList?.length - 1
                                            : msg.cardIndex - 1,
                                      }
                                    : msg
                                )
                              );
                            }}
                          >
                            {message?.cardIndex + 1 == 1 ? (
                              <CardArrowIconDisabled
                                style={{
                                  width: 16,
                                  height: 16,
                                }}
                              />
                            ) : (
                              <CardArrowIcon
                                style={{
                                  width: 16,
                                  height: 16,
                                }}
                              />
                            )}
                          </div>
                          <div
                            className="MessageCardDiv_button_icon_item"
                            style={{
                              transform: device == 'mobile' ? 'scale(1.5)' : 'scale(1)',
                            }}
                            onClick={() => {
                              if (message?.cardIndex + 1 == message?.content?.cardList?.length) {
                                return;
                              }
                              setMessageList((prevList) =>
                                prevList.map((msg) =>
                                  msg === message
                                    ? {
                                        ...msg,
                                        cardIndex:
                                          msg.cardIndex + 1 == msg?.content?.cardList?.length ? 0 : msg.cardIndex + 1,
                                      }
                                    : msg
                                )
                              );
                            }}
                          >
                            {message?.cardIndex + 1 == message?.content?.cardList?.length ? (
                              <CardArrowIconDisabled
                                style={{
                                  width: 16,
                                  height: 16,
                                }}
                              />
                            ) : (
                              <CardArrowIcon
                                style={{
                                  width: 16,
                                  height: 16,
                                }}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div style={{ fontSize: '16px', marginBottom: 5 }}>{message?.content?.botMessage}</div>
                      {message?.content?.cardList?.map((ele, index) => {
                        return (
                          <div
                            className="live_MessageCardDiv2"
                            onClick={(e) => {
                              e.stopPropagation();
                              // sendMessage(ele, 'Form');
                            }}
                          >
                            <div
                              className="MessageCardDiv2_img"
                              style={{
                                width: '70px',
                                height: '70px',
                                // border: '1px solid blue',
                              }}
                            >
                              {/* {ExampleImg(50)} */}
                              <img
                                style={{
                                  width: '100%',
                                  height: '100%',
                                }}
                                src={ele.cardImageUrl}
                                alt=""
                              />
                            </div>
                            <div style={{ width: 'calc(100% - 70px)', padding: '0px 5px' }}>
                              <div className="MessageCardDiv2_title">
                                <div className="MessageCardDiv2_title_text">
                                  <span>{ele.cardTitle}</span>
                                </div>
                                <div className="MessageCardDiv2_title_price">
                                  <div>
                                    <span>{ele.cardPrice}</span>
                                  </div>
                                  {ele.cardNumber && (
                                    <div style={{ color: '#999', fontSize: '12px' }}>x{ele.cardNumber}</div>
                                  )}
                                </div>
                              </div>
                              <div className="MessageCardDiv2_status">
                                <span>{ele.cardStatus}</span>
                                {!message.disabled && (
                                  <span
                                    style={{
                                      padding: device == 'mobile' ? '3px 12px' : '3px 10px',
                                      transform: device == 'mobile' ? 'scale(0.8)' : '',
                                      borderRadius: '5px',
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setMessageList((prevList) => {
                                        return prevList.map((m) => {
                                          if (m.msgId === message.msgId) {
                                            return { ...m, disabled: true };
                                          }
                                          return m;
                                        });
                                      });
                                      handleClickMessage({
                                        type: 'card2',
                                        content: JSON.stringify({ ...ele, cardLayout: 2 }),
                                      });
                                    }}
                                  >
                                    {chatConfig.cardChoice}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </>
                  )}
                </AgentContent>
              ) : (
                <AgentContent
                  $device={device}
                  $chatservicecolor={chatConfig.chatServiceColor}
                  $chatmessagecolor={chatConfig.chatMessageColor}
                >
                  <ReactMarkdown components={{ a: LinkRenderer, img: ImgRenderer }}>{message.content}</ReactMarkdown>
                  {message.isShowLikeBut ? (
                    <LikeButContainer>
                      <span
                        onClick={() => {
                          handleClickLikeIcon(message, 1);
                        }}
                      >
                        {message.likeStatus === 1 ? zanBrightIcon('#3463FC') : zanDarkIcon('#999999')}
                      </span>
                      <span></span>
                      <span
                        onClick={() => {
                          handleClickLikeIcon(message, 2);
                        }}
                      >
                        {message.likeStatus === 2 ? zanBrightIcon('#F22417') : zanDarkIcon('#999999')}
                      </span>
                    </LikeButContainer>
                  ) : (
                    ''
                  )}
                </AgentContent>
              )}
            </AgentContentWrapper>
            {!message.disabled && message.data?.buttons?.length > 0 ? (
              <AgentList
                $device={device}
                $chatmessagecolor={chatConfig.chatMessageColor}
                style={{ flexDirection: message.data.displayType == 1 ? 'row' : 'column' }}
              >
                {agentDisabled &&
                  message.data?.buttons?.map((item, index1) => {
                    return (
                      <ListItem
                        $device={device}
                        key={index1 + 1000}
                        onClick={() => {
                          let obj = {
                            content: item.buttonName,
                          };
                          handleClickButton(obj, index, message);
                        }}
                        $chatservicecolor={chatConfig.chatServiceColor}
                        $chatmessagecolor={chatConfig.chatMessageColor}
                      >
                        {item.buttonName}
                        <ButtonArrow />
                      </ListItem>
                    );
                  })}
              </AgentList>
            ) : (
              ''
            )}
            <div className="llmTips">{message.type == 'ToolLLM' ? message.aiMessage : ''}</div>
            {/* <span
              className="messageTime"
              style={{
                marginLeft: device == 'mobile' ? '40px' : '32px',
                marginTop: device == 'mobile' ? '-3px' : message.aiMessage ? '-2px' : '-7px',
              }}
            >
              {message.time}
            </span> */}
          </ChatMessageAgentWrapper>
        ) : (
          <ChatMessageAgentWrapper>
            <AgentInfo $device={device}>
              {chatConfig.chatRobotIcon ? (
                <img src={chatConfig.chatRobotIcon} alt="" />
              ) : (
                agent(chatConfig.chatThemeColor)
              )}
              <span>{message.displayName}</span>
            </AgentInfo>

            <AgentContentWrapper $device={device}>
              <AgentContent
                $device={device}
                $chatservicecolor={chatConfig.chatServiceColor}
                $chatmessagecolor={chatConfig.chatMessageColor}
              >
                <Spinner $chatmessagecolor={chatConfig.chatMessageColor}>
                  <span></span>
                  <span></span>
                  <span></span>
                </Spinner>
              </AgentContent>
            </AgentContentWrapper>
          </ChatMessageAgentWrapper>
        )}
      </CSSTransition>
    );
  }

  function LinkRenderer(props) {
    return (
      <a href={props.href} target="_blank" rel="noreferrer">
        {props.children}
      </a>
    );
  }

  function ImgRenderer(props) {
    let src = props.src;
    return <Image src={src} />;
  }

  /**
   * 满意度评价
   * @param message
   * @param index
   */
  function evaluationMessage(message, index) {
    let starCount = 5;
    /**
     * 处理选择评分事件
     */
    const handleRateChange = (e, message) => {
      setShowGif(true);
      setTimeout(() => {
        setShowGif(false);
      }, 1000);
      if (message.disabled) return;
      message.disabled = true;
      message.content = e;
      handleClickRate(e, message);
    };
    const messageArr = [{}];
    return (
      <CSSTransition key={index} in={true} appear={true} timeout={3000} classNames="message">
        <EvaluationDiv>
          <EvaluationLine
            $chatservicecolor={chatConfig.chatServiceColor}
            $chatmessagecolor={chatConfig.chatMessageColor}
          ></EvaluationLine>
          <div style={{ marginBottom: 10, color: '#666', fontSize: 12 }}>
            {' '}
            {chatConfig.satisfactionEvaluationMessage}
          </div>
          <div style={{ position: 'relative' }}>
            <img
              src="https://chat.connectnow.cn/evaluate.1a9bd5a6.gif"
              style={{
                width: 250,
                height: 'auto',
                position: 'absolute',
                top: '-90px',
                right: '-35px',
                zIndex: 99,
                display: showGif ? 'block' : 'none',
              }}
            />

            <Rate
              value={message.content}
              count={starCount}
              disabled={message.disabled}
              allowClear={false}
              allowHalf={false} // 是否可以选择半星
              onChange={(value) => handleRateChange(value, message)}
              style={{ fontSize: 30 }}
            />
          </div>
        </EvaluationDiv>
      </CSSTransition>
    );
  }

  /**
   * 上传中消息
   * @param message
   * @param index
   */
  function uploadingMessage(message, index) {}

  return (
    <MessageBody ref={messageBodyRef}>
      {messageList?.map((message, index) => {
        return messageTypeAnalyzer(message, index);
      })}
    </MessageBody>
  );
};

const zanDarkIcon = (color = '#999999') => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.71632 6H2.35826C1.60822 6 1.0002 6.59695 1.0002 7.33333V12C1.0002 12.7364 1.60822 13.3333 2.35826 13.3333H3.71632C4.46636 13.3333 5.07439 12.7364 5.07439 12V7.33333C5.07439 6.59695 4.46636 6 3.71632 6Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4231 14H7.93386C7.39763 14 6.8734 13.8442 6.42723 13.5521L5.37676 12.8646C5.18786 12.7409 5.07439 12.5328 5.07439 12.3099V6.84371C5.07439 6.72769 5.10523 6.61368 5.16386 6.51295L7.50127 2.49697C7.68035 2.18928 8.00952 2 8.36554 2H8.69275C10.0486 2 10.8573 3.48357 10.1052 4.59117L9.14858 6H12.8415C13.725 6 14.3733 6.81518 14.159 7.65671L13.0581 11.9801C12.7558 13.1672 11.6694 14 10.4231 14Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const zanBrightIcon = (color) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.27409 14H10.4238C11.6701 14 12.7565 13.1672 13.0588 11.9801L14.1597 7.65671C14.374 6.81518 13.7257 6 12.8422 6H9.48881L10.3762 4.50645C11.0364 3.39536 10.22 2 8.90987 2H8.70577C8.34975 2 8.02058 2.18928 7.8415 2.49697L5.50409 6.51295C5.44546 6.61368 5.41462 6.72769 5.41462 6.84371V12.3099C5.41462 12.5328 5.52809 12.7409 5.717 12.8646L6.76746 13.5521C7.21363 13.8442 7.73786 14 8.27409 14Z"
        fill={color}
      />
      <path
        d="M2.6 6H3.4C4.28366 6 5 6.56982 5 7.27273V11.7273C5 12.4302 4.28366 13 3.4 13H2.6C1.71634 13 1 12.4302 1 11.7273V7.27273C1 6.56982 1.71634 6 2.6 6Z"
        fill={color}
      />
    </svg>
  );
};

export default ChatMessageAmazon;
